import { Flex, Spinner } from '@chakra-ui/react';
import { PageContainer, PageHeader } from 'components/ds';
import { getStorage, STORAGE_KEY } from 'helpers/storage';
import { useTranslation } from 'react-i18next';

import UploadInput from './UploadInput';

const Upload = () => {
  const { t } = useTranslation();

  const SpinnerCentered = () => (
    <Flex
      pos='fixed'
      zIndex='999'
      top='0'
      right='0'
      bottom='0'
      left='0'
      align='center'
      justify='center'
      w='100vw'
      h='100vh'
    >
      <Spinner color='primary.solid' size='xl' speed='0.65s' thickness='4px' />
    </Flex>
  );

  return getStorage(STORAGE_KEY.TOKEN) ? (
    <PageContainer>
      {/* Page header — aligns to page left edge, full container width (mockup: .page-header) */}
      <PageHeader title={t('upload.title')} subtitle={t('upload.subtitle')} />

      {/* Dropzone + queue use the page container width to match mockup's wider content */}
      <UploadInput />
    </PageContainer>
  ) : (
    <SpinnerCentered />
  );
};

export default Upload;
